import { Component, OnInit } from '@angular/core';
import { AccountMixin } from 'src/app/services/mixins/account.mixin';
import { PageService } from 'src/app/services/page.service';
import { Title, Meta } from '@angular/platform-browser';
import { Router } from '@angular/router';
import { InfoService } from 'src/app/services/info.service';
import { map, Observable } from 'rxjs';

import { Select } from '@ngxs/store';
import { UserState } from 'src/app/store/states/user.state';

import { groupBy, forEach } from 'lodash-es';
import { PaymentService } from '@services/payment.service';

import { PaymentTransactions } from '@interfaces/payment.interface';

import APP_CONFIG from 'src/app/config/app.config';

import { TranslateService } from '@ngx-translate/core';

import { BaseComponent } from '../../base.component';


@Component({
    selector: 'app-dashboard-transactions',
    templateUrl: './transactions.component.html',

})
export class TransactionsComponent extends AccountMixin(BaseComponent) implements OnInit {
    @Select(UserState.lastSign)
    public lastSign$: Observable<any | null>;

    public actualTime: any;

    public data:PaymentTransactions[];
    public annual: boolean = false;


    public constructor(
        protected page: PageService,
        public payment: PaymentService,
        private translate: TranslateService,
        protected title?: Title,
        protected meta?: Meta,
        protected route?: Router,
        protected info?: InfoService,
    ) {
        super(page, title, meta, route, info);
    }

    get getNoData():boolean {
        return Object.keys(this.data).length === 0;
    }

    public ngOnInit(): void {
        this.payment.getTransactions().pipe(map((val: PaymentTransactions[]): PaymentTransactions[] => {
            val = val.filter((v: any) => v.subscription !== null);

            val.forEach((v: any) => {
                v['session_data'] = this.payment.mapSerializeData(v['session_data']);
                v['error_data'] = this.payment.mapSerializeData(v['error_data']);
                v['checkout_data'] = this.payment.mapSerializeData(v['checkout_data']);
            });

            const data = groupBy(val, 'subscription') as any;

            forEach(data, (v: any, k: any) => {
                data[k] = groupBy(data[k], 'status');
            });

            return data;
        })).subscribe((val) => {
            this.data = val;

            this.finished();
        }, () => {
            this.error();
        });
    }

    get lang(): string {
        return this.translate.currentLang ?? APP_CONFIG.defaultLang;
    }
}
